module.exports = __webpack_public_path__ + "images/header_nav/icon-bell.png";